

export const targetAppContstants ={

    order:"order",
    reservation:"reservation",
    appointment:"appointment",
    coffeeproject:"coffeeproject",
    chatshireQr:"chatshireQr",
    campaign:"campaign",
    event:"event",
}

 